import './UserMenuIcon.scss';

import { LoadingOutlined } from '@ant-design/icons';
import { Avatar, Popover } from 'antd';
import { useMemo, useState } from 'react';

import User from '@/model/General/User';

import UserMenuContent from './UserMenuContent';

interface UserMenuIconProps {
  user?: User;
}

const UserMenuIcon = (props: UserMenuIconProps) => {
  const { user } = props;
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const userNameInitials = useMemo(
    () => '' + user?.firstName?.charAt(0) + user?.lastName?.charAt(0),
    [user],
  );

  return (
    <div className="UserMenuIcon">
      <Popover
        placement="bottomRight"
        content={<UserMenuContent />}
        open={openUserMenu}
        onOpenChange={(visible: boolean) => setOpenUserMenu(visible)}
        trigger="click">
        <Avatar size="small" className="UserMenuIconAvatar">
          {user && userNameInitials != '' ? userNameInitials.toUpperCase() : <LoadingOutlined />}
        </Avatar>
      </Popover>
    </div>
  );
};

export default UserMenuIcon;
